import React from 'react';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react'

//redux
import { useDispatch } from "react-redux";
import { changeTheme, changeSidebarType, changeTopbarTheme, changeSidebarTheme } from '../../store/actions';
import { themeModeTypes, leftSidebarTypes } from '../../constants/layout';

// import Img
import logo from "../../assets/images/white logo png.png";
import logoBlack from "../../assets/images/black logo png.png";
import logoBlackSmall from "../../assets/images/black icon png-01-01.png";
import logoSmall from "../../assets/images/white icon png-01.png";
import ProfileMenu from '../../components/Common/TopbarDropdown/ProfileMenu';
import NotificationDropdown from '../../components/Common/TopbarDropdown/NotificationDropdown';
import LanguageDropdown from '../../components/Common/TopbarDropdown/LanguageDropdown';


const Header = ({ themeMode }) => {
    const mode = themeMode === themeModeTypes['DARK'] ? themeModeTypes['LIGHT'] : themeModeTypes['DARK'];

    const dispatch = useDispatch();

    function tToggle() {
        var body = document.body;
        if (window.innerWidth <= 998) {
            body.classList.toggle("sidebar-enable");
        } else {
            body.classList.toggle("sidebar-enable");
            body.classList.toggle("vertical-collpsed");
            dispatch(changeSidebarType(leftSidebarTypes.DEFAULT))
        }
    }

    return (
        <React.Fragment>
            <header id="page-topbar" className="isvertical-topbar">
                <div className="navbar-header">
                    <div className="d-flex">
                          <div className="navbar-brand-box">
                    <Link to="/reactive" className="logo logo-dark">
                        <span className="logo-sm">
                            <img src={logoBlackSmall} alt="" height="27" />
                        </span>
                        <span className="logo-lg">
                            <img src={logoBlack} alt="" height="40" width={150} />
                        </span>
                    </Link>
                    <Link to="/reactive" className="logo logo-light">
                        <span className="logo-lg">
                            <img src={logo} alt="" height="60" width={150}/>
                        </span>
                        <span className="logo-sm">
                            <img src={logoSmall} alt="" height="27" />
                        </span>
                    </Link>
                </div>

                        <button type="button" className="btn btn-sm px-3 font-size-16 header-item vertical-menu-btn"
                            onClick={() => {
                                tToggle()
                            }}
                        >
                            <i className="fa fa-fw fa-bars"></i>
                        </button>
                    </div>

                    <div className="d-flex">

                        <LanguageDropdown />
                        <NotificationDropdown />

                        <div className="dropdown d-none d-sm-inline-block">
                            <button onClick={() => {
                                dispatch(changeTheme(mode));
                                dispatch(changeTopbarTheme(mode))
                                dispatch(changeSidebarTheme(mode))
                            }}
                                type="button" className="btn header-item">

                                {themeMode === themeModeTypes['DARK'] ?
                                    <FeatherIcon
                                        icon="moon"
                                        className="icon-sm layout-mode-dark"
                                    />
                                    :
                                    <FeatherIcon
                                        icon="sun"
                                        className="icon-sm layout-mode-light"
                                    />
                                }
                            </button>
                        </div>
                        <ProfileMenu />
                    </div>
                </div>
            </header>
        </React.Fragment>
    )
}

export default Header;




